<template>
  <form
    id="modal-new-password"
    @submit.prevent="sendForgetPassword()"
  >
    <div id="close-icon">
      <img
        src="../../assets/icons/icon_close.svg"
        @click="toggleNewPassword()"
      />
    </div>
    <div
      id="title-modal"
      class="gotham-bold"
    >
      Lupa Kata Sandi
    </div>
    <div id="modal-description">
      Silakan masukkan email yang sebelumnya terdaftar, link reset kata sandi baru akan dikirim ke email Anda
    </div>
    <div id="input-email">
      <div
        class="error-password"
        v-if="errorEmail"
      >Email belum terdaftar. Silakan klik Daftar!</div>
      <input
        type="email"
        placeholder="Email"
        :class="{'input-error': errorEmail}"
        v-model="email"
      />
    </div>
    <div id="button-submit">
      <button
        v-if="!email"
        disabled
        class="button-disabled"
      >Lanjut</button>
      <button
        v-else-if="isLoading"
        disabled
        class="button-loading"
      >
        <span class="spinner-border spinner-border-sm text-primary" role="status"/> Lanjut
      </button>
      <button
        v-else
        class="button-active"
      >Lanjut</button>
    </div>
    <div id="footer-modal">
      Kembali ke halaman <span @click="toggleMasuk()">Masuk</span> atau <span @click="toggleDaftar()">Daftar</span>
    </div>
  </form>
</template>

<script>
import axiosServer from '../../configs/axiosServer'

export default {
  data () {
    return {
      isLoading: false,
      errorEmail: ''
    }
  },
  methods: {
    toggleNewPassword () {
      this.$emit('toggleNewPassword')
    },
    toggleMasuk () {
      this.$emit('toggleMasuk')
    },
    toggleDaftar () {
      this.$emit('toggleDaftar')
    },
    async sendForgetPassword () {
      this.isLoading = true
      try {
        const { data } = await axiosServer({
          url: '/user/send_forget_password/',
          method: 'POST',
          headers: {
            Authorization: process.env.VUE_APP_APP_KEY
          },
          data: {
            email: this.email
          }
        })
        this.errorEmail = ''
        this.isLoading = false
        if (data.status === 200) {
          this.$emit('toggleConfirmationPassword')
        } else {
          this.errorEmail = data.message
        }
      } catch (error) {
        console.error(error)
        this.isLoading = false
      }
    },
    async sendNewPassword () {
      this.isLoading = true
      try {
        const { data } = await axiosServer({
          url: '/user/recover_password/',
          method: 'post',
          headers: {
            Authorization: process.env.VUE_APP_APP_KEY
          },
          data: {
            email: this.email
          }
        })
        this.errorEmail = ''
        this.isLoading = false
        if (data.status === 200) {
          this.$emit('toggleConfirmationPassword')
        } else {
          this.errorEmail = data.message
        }
      } catch (err) {
        console.error(err)
        this.isLoading = false
      }
    }
  },
  computed: {
    emailActive () {
      if (this.email) {
        return true
      } else {
        return false
      }
    },
    email: {
      get () {
        return this.$store.state.login.email
      },
      set (value) {
        this.$store.commit('login/SET_EMAIL', value)
      }
    }
  }
}
</script>

<style scoped>
#modal-new-password {
  padding: 0px 13px;
}

#close-icon {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 15px;
}

#close-icon img {
  cursor: pointer;
}

#title-modal {
  color: #172d5c;
  font-size: 20px;
  text-align: center;
}

#modal-description {
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 15px;
}

#input-email {
  margin-top: 15px;
}

#input-email input {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  border-radius: 10px;
  width: 100%;
  padding: 10px 15px;
  color: rgba(0, 0, 0, 0.7);
}

::placeholder {
  color: rgba(0, 0, 0, 0.3);
}

#button-submit {
  margin-top: 15px;
}

#button-submit .button-disabled {
  padding: 10px 15px;
  background: #e0e0e0;
  border-radius: 10px;
  width: 100%;
  border: 1px solid #e0e0e0;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 600;
}

.button-loading {
  padding: 10px 15px;
  background: #2b7eb5;
  border-radius: 10px;
  width: 100%;
  border: 1px solid #2b7eb5;
  color: #fff;
  font-weight: 600;
  outline: none;
}

.button-active {
  padding: 10px 15px;
  background: #3498db;
  border-radius: 10px;
  width: 100%;
  border: 1px solid #3498db;
  color: #fff;
  font-weight: 600;
  outline: none;
}

.button-active:hover {
  background-color: #2b7eb5;
  border: 1px solid #2b7eb5;
}

#footer-modal {
  margin-top: 15px;
  color: rgba(0, 0, 0, 0.7);
  text-align: center;
}

#footer-modal span {
  color: #ffc429;
  cursor: pointer;
}

#footer-modal span:hover {
  text-decoration: underline;
}

.error-password {
  color: #eb5757;
}

.input-error {
  border: 1px solid #eb5757 !important;
}
</style>
